import { US_STATES } from '@cibo/core'
import { createFilterOptions } from '@mui/material/Autocomplete'
import { useField } from 'formik'
import { propEq } from 'ramda'
import { useEffect } from 'react'
import { AutocompleteField, AutocompleteFieldProps } from '../../AutocompleteField'

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option: { abbreviation: string; label: string }) =>
    `${option.label} ${option.abbreviation}`,
})

const optionTest = (option: { label: string }, value: string | { label: string }) => {
  if (typeof value === 'string') {
    return value === option.label
  } else {
    return value.label === option.label
  }
}

export const StatePickerField = ({
  name = 'state',
  ...autocompleteProps
}: AutocompleteFieldProps) => {
  const [_, { initialValue }, { setValue }] = useField(name)

  useEffect(() => {
    const valueOption = US_STATES.find(propEq('label', initialValue))
    if (valueOption) setValue(valueOption)
  }, [initialValue])

  return (
    <AutocompleteField
      freeSolo
      autoSelect
      name={name}
      options={US_STATES}
      getOptionLabel={option => (typeof option === 'string' ? option : option.label)}
      selectOnFocus
      isOptionEqualToValue={optionTest}
      filterOptions={filterOptions}
      {...autocompleteProps}
    />
  )
}
